import React, { Component } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Slide,
  TextField,
  CircularProgress,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { connect } from 'react-redux';

import WalletsDuck from '../../../ducks/WalletsDuck';
import { openSnackbar } from '../../../components/Notifier';

const styles = (theme) => ({
  prompt: {
    marginBottom: theme.spacing.unit,
  },
  progressWrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
    display: 'inline-block',
  },
  buttonProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class AddNewPartnerModal extends Component {
  state = {
    partnerName: '',
    isSubmitting: false,
  };

  render() {
    const { classes } = this.props;
    return (
      <Dialog
        open={this.props.open}
        TransitionComponent={Transition}
        aria-labelledby="Add new partner"
        onClose={this.props.onClose}
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle id="form-dialog-title">Add new partner</DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.prompt}>
            Please provide a unique ID or description of the partner.
          </DialogContentText>
          <TextField
            margin="dense"
            id="partnerName"
            label="Partner Name"
            type="text"
            fullWidth
            value={this.state.partnerName}
            onChange={(event) =>
              this.setState({ partnerName: event.target.value })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} color="default">
            Cancel
          </Button>
          <div className={classes.progressWrapper}>
            <Button
              onClick={this.createPartner}
              color="primary"
              disabled={this.state.isSubmitting}
            >
              Submit
            </Button>
            {this.state.isSubmitting && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </DialogActions>
      </Dialog>
    );
  }

  createPartner = () => {
    this.setState({ isSubmitting: true });
    debugger;
    this.props.createWallet(this.props.token, this.state.partnerName).then(
      () => {
        openSnackbar({ message: 'Virtual Wallet successfully created.' });
        this.setState({ isSubmitting: false });
        this.props.onClose();
      },
      () => {
        this.setState({ isSubmitting: false });
        openSnackbar({ message: 'An error occurred, please try again.' });
      },
    );
  };
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createWallet: (token, email, externalReferenceId) => {
      return dispatch(
        WalletsDuck.creators.createWallet(token, email, externalReferenceId),
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(AddNewPartnerModal));
